module.exports = __webpack_public_path__ + "static/img/zjnd.ce79137.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/zjnd.jpg
// module id = uCEs
// module chunks = 21